import c from '../common';

export default {
  "recordId": "記錄編號",
  "orderTime": "下單時間",
  "status": c.status.chn,
  "orderType": "種類",
  "district": "地區",
  "deliveryDistrict": "送貨地區",
  "deliveryAddress": "送貨地址",
  "deliveryDate": "送貨時間",
  "options": "產品",
  "customer": "聯絡人",
  "customerTel": "聯絡人電話",


  "ordered": "已下單",
  "detail": "詳情",


  //DB data
  "morning": "上午",
  "afternoon": "下午",
  "IN_STORE_REDEEM": "門店換領",
  "DELIVERY_REDEEM": "送貨"
};